import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["icon", "content", "card"];

  connect() { }

  toogle(e) {
    e.preventDefault();

    let current_id = e.currentTarget.dataset.id;
    let content = this.contentTargets.find(
      (elem) => elem.dataset.id === current_id
    );

    let icon = this.iconTargets.find((elem) => elem.dataset.id === current_id);
    if (content.dataset.expanded === "1") {
      this.collapse(content, icon);
    } else {
      this.expand(content, icon);
    }
  }

  collapse(content, icon) {
    content.classList.remove("show");
    icon.classList.remove("fa-rotate-90", "mr-1");
    content.dataset.expanded = "0";
  }

  expand(content, icon) {
    content.classList.add("show");
    icon.classList.add("fa-rotate-90", "mr-1");
    content.dataset.expanded = "1";
  }
}
